import { Injectable } from '@angular/core'
import { MainBusinessRecord } from '@models/ui'
import { forEach } from 'lodash-es'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class RecordActionPanelService {
    private selectedRecords: Set<MainBusinessRecord> = new Set()
    private readonly selectRecords$ = new BehaviorSubject(Array.from(this.selectedRecords))

    constructor() {}

    select(value: MainBusinessRecord) {
        this.selectedRecords.add(value)
        this.notifyUpdatedRecords()
    }

    selectRecords(records: MainBusinessRecord[]) {
        records.forEach((value) => {
            this.selectedRecords.add(value)
        })
        this.notifyUpdatedRecords()
    }

    toggle(value: MainBusinessRecord) {
        if (this.isSelected(value)) {
            this.deselect(value)
            return
        }

        this.select(value)
    }

    toggleRecords(values: MainBusinessRecord[]) {
        if (this.areSelected(values)) {
            this.deselectRecords(values)
            return
        }

        this.selectRecords(values)
    }

    isSelected(value: MainBusinessRecord) {
        return this.selectedRecords.has(value)
    }

    areSelected(values: MainBusinessRecord[]) {
        return values.every((value) => {
            return this.isSelected(value)
        })
    }

    deselect(value: MainBusinessRecord) {
        this.selectedRecords.delete(value)
        this.notifyUpdatedRecords()
    }

    deselectRecords(values: MainBusinessRecord[]) {
        forEach(values, (value) => {
            this.selectedRecords.delete(value)
        })
        this.notifyUpdatedRecords()
    }

    deselectAll() {
        this.selectedRecords.clear()
        this.notifyUpdatedRecords()
    }

    getSelectedRecords$() {
        return this.selectRecords$.asObservable()
    }

    private notifyUpdatedRecords() {
        this.selectRecords$.next(Array.from(this.selectedRecords))
    }
}
